import { Observable } from 'rxjs';
import { Size } from '../../Models/Geometry/Size';
import { WebGLImageFilter } from '../../Utils/ImageFilter';
import { ImageWorker } from '../ImageWorker/ImageWorker';
import { ImageFilterer } from './ImageFilterer';
import { ImageFilter } from './Models/ImageFilter';

export class WebGLImageFilterer extends ImageWorker implements ImageFilterer {
  public applyFilters(image: HTMLImageElement, filters: ImageFilter[]): Observable<HTMLImageElement> {
    const imageSize: Size = this.getImageSize(image);
    const canvas: HTMLCanvasElement = this.canvasFromImage(image, imageSize);
    const webGLFilter = new WebGLImageFilter();
    filters.forEach((filter) => webGLFilter.addFilter(filter.name, filter.value));
    const filterCanvas: HTMLCanvasElement = webGLFilter.apply(canvas);
    return this.createImageFromDataUrl(filterCanvas.toDataURL(), imageSize);
  }

  private canvasFromImage(image: HTMLImageElement, { width, height }: Size): HTMLCanvasElement {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Unable to get 2d context');
    }
    ctx.drawImage(image, 0, 0, width, height);

    return canvas;
  }
}
